import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


const T = ({ value, columns }) => {
	if (!value || !Array.isArray(value)) return null;

	return (
		<Paper variant='outlined'>
			<Table size='small'>
				<TableHead>
					<TableRow>
						{columns?.map(c => <TableCell>{c.headerName}</TableCell>)}
					</TableRow>
				</TableHead>
				<TableBody>
					{value?.map(row => (
						<TableRow
							key={row.id}
							sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
						>
							{columns?.map(c => <TableCell>{row[c.field]}</TableCell>)}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Paper>
	);
};

T.type = 'Table';

export default T;